import React, { useState } from "react";
import { Button, Modal, notification } from "antd";
import { useCacheDataMutation, useClearCacheMutation } from "../../redux/api/genericReporting";

const AdminCacheManagementTab = () => {
  const [cacheData] = useCacheDataMutation();
  const [clearCache] = useClearCacheMutation();
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = (type) => {
    setActionType(type);
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    setIsLoading(true);
    try {
      if (actionType === 'clear') {
        await clearCache().unwrap();
        notification.success({
          message: 'Cache Cleared',
          description: 'The cache has been successfully cleared.',
        });
      } else if (actionType === 'recalculate') {
        await cacheData().unwrap();
        notification.success({
          message: 'Cache Recalculated',
          description: 'The cache has been successfully recalculated.',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Operation Failed',
        description: error?.data?.message || 'An error occurred while processing your request.',
      });
    } finally {
      setIsLoading(false);
      setIsModalVisible(false);
      setActionType(null);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setActionType(null);
  };

  const getModalTitle = () => {
    return actionType === 'clear' ? 'Clear Cache' : 'Re-Calculate Cache';
  };

  const getModalContent = () => {
    return actionType === 'clear' 
      ? 'Are you sure you want to clear the cache? This action cannot be undone.'
      : 'Are you sure you want to re-calculate the cache? This may take some time.';
  };

  return (
    <div style={{
      height: "50vh",
      width: "60vw",
    }}>
      <Button 
        style={{
          marginRight: "10px",
        }} 
        type="primary" 
        onClick={() => showModal('clear')}
      >
        Clear Cache
      </Button>
      <Button 
        style={{
          marginRight: "10px",
        }} 
        type="primary" 
        onClick={() => showModal('recalculate')}
      >
        Re-Calculate Cache
      </Button>

      <Modal
        title={getModalTitle()}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirm"
        cancelText="Cancel"
        confirmLoading={isLoading}
      >
        <p>{getModalContent()}</p>
      </Modal>
    </div>
  );
};

export default AdminCacheManagementTab; 